import { useCallback } from 'react';

import useEmployeeTopbarStore, { EmployeeToolbarPayload } from '../EmployeeTopbar/stores/useEmployeeTopbar.store';
import useOrganizationInfoStore, { OrganizationInfo } from '../PersonalInformation/OrganizationInfo/stores/useOrganizationInfo.store';
import usePersonalInformationStore, { PersonalInformationPayload } from '../PersonalInformation/stores/usePersonalInformation.store';
import useRegistrationAndLoginStore, { RegistrationAndLoginPayload } from '../RegistrationAndLogin/stores/useRegistrationAndLogin.store';

export type EmployeePayload = PersonalInformationPayload
& EmployeeToolbarPayload & OrganizationInfo & RegistrationAndLoginPayload;

export default () => {
  const {
    handleSetSourceState: setPersonalSourceState,
    handleReset: handleResetGeneralInfo,
  } = usePersonalInformationStore();

  const {
    handleSetSourceState: setRegistrationAndLoginState,
    handleReset: resetRegistrationAndLoginState,
  } = useRegistrationAndLoginStore();

  const {
    setSourceState: setEmployeeTopbarSourceState,
    handleReset: handleResetEmployeeTopbar,
  } = useEmployeeTopbarStore();

  const {
    setSourceState: setOrganizationInfoSourceState,
    handleReset: handleResetOrganizationInfo,
  } = useOrganizationInfoStore();

  const setSourceState = useCallback((values: Partial<EmployeePayload>) => {
    setPersonalSourceState(values);
    setEmployeeTopbarSourceState(values);
    setOrganizationInfoSourceState(values);
    setRegistrationAndLoginState(values);
  }, [setEmployeeTopbarSourceState, setOrganizationInfoSourceState, setPersonalSourceState, setRegistrationAndLoginState]);

  const handleReset = useCallback(() => {
    handleResetGeneralInfo();
    handleResetEmployeeTopbar();
    handleResetOrganizationInfo();
    resetRegistrationAndLoginState();
  }, [handleResetEmployeeTopbar, handleResetGeneralInfo, handleResetOrganizationInfo, resetRegistrationAndLoginState]);
  return {

    setSourceState,
    handleResets: handleReset,
  };
};
